<template>
	 <div class="cancel_main">
         <div class="inp_box clearfix">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-select v-model="selectValue" placeholder="请选择类型" >
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>         
                <el-input v-model="inpData" placeholder="篇名，作者，发表日期" class="inp_item"></el-input>
                <el-button type="primary"  @click="searchClick()" :loading="logining" >查询</el-button>
                 <el-button type="primary"  @click="resetClick()" :loading="logining">重置</el-button>
                    <!-- <el-form-item>
                        <el-button type="primary"  >新增</el-button>
                    </el-form-item> -->
            </el-col>
            <div class="btn_box">
                <el-button type="primary" :disabled='item.isDisabled' ref='typBtn' plain round size=mini  v-for='(item,index) in btnData' :key='index' :data-value='item.value' @click='addInpData(index,item.value)'>{{item.name}}</el-button>
                <!-- <el-button type="primary" plain round size=mini>作者</el-button> -->
                <!-- <el-button type="primary" plain round size=mini>日期</el-button> -->
            </div>
         </div>
         <div class="tab_wrapper">
            <div class="tab_itemBox clearfix" v-for='(item,index) in tabData' :key='index'>
                <el-row class="clearfix">
                    <el-col :span="12"><div class="grid-content bg-purple tab_title" >
                        <span class="">{{item.KbaseTableName}}({{item.Totals}})条</span>
                    </div></el-col>
                    <!-- <el-col :span="12"><div class="grid-content bg-purple-light item_num">查询到xxx条数据</div></el-col> -->
                </el-row>
                <el-table
                    :data="item.ListDetails"
                    stripe
                    style="width: 100%"  height="250" border>
                    <el-table-column
                    prop="Pianming"
                    label="篇名"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="Zuozhe"
                    label="作者"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="WenJianMing"
                    label="文件名"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="FaBiaoRiQi"
                    label="发表日期"
                    >
                    </el-table-column>
                    <el-table-column
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-button type="text" size="small" @click="dialogTableVisible = true">编辑</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        
        <uploader ref="uploader" :options="loadOptions" :fileStatusText="fileStatusText"   :class="{'uploader-example':true,'show-remove':uploadSuccess}" @files-added="onFilesAdded" @upload-start='uploadStart' @file-added="onFileAdded"  @file-progress="onFileProgress"  @file-success="onFileSuccess" @files-submitted="filesSubmitted" @file-error="onFileError" >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
                <p>Drop files here to upload or</p>
                <uploader-btn :single='single'>选择文件</uploader-btn>
                <!-- <uploader-btn :attrs="attrs">select images</uploader-btn>
                <uploader-btn :directory="true">select folder</uploader-btn> -->
            </uploader-drop>
            <uploader-list ref="fileList"></uploader-list>
        </uploader>
        <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
           <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
     </div>
</template>

<script>
    //import util from '../../common/js/util'
     
    import { getUserListPage, removeUser, batchRemoveUser, editUser, addUser } from '../../api/api';
	export default {
        components: {
            // vueUpload
        },
        computed: {
            uploader() {
                return this.$refs.uploader;
            }
        },
        watch:{
            inpData(val){
                if(!this.$util.isnull(val)){
                   this.btnData.forEach((item,index,arr)=>{
                       item.isDisabled=false;
                   })
                }
            }
        },
         methods: {
            //上传开始
            onFileAdded(file) {
                console.log("file=====",file)
                file.pause();
                this.panelShow = true;
                var paramsData={
                    FileOriginalName:file.name,
                    UploadFileType :"1"
                }
                //var paramsData = '?FileOriginalName='+file.name+'&UploadFileType=1'
                this.$api.SimpleUploadToken(paramsData).then(res => {
                        file.uniqueIdentifier = res.data.Token;
                        file.resume();
                });
            },
            onFilesAdded(files, fileList, event){          
            },
            filesSubmitted(files, fileList, event){
                
            },
            getToken(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let md5 = '';
                let that = this;
                this.$api.SimpleUploadToken().then(res => {
                        file.pause();
                        file.uniqueIdentifier = res.data.Token;
                        file.resume();
                        console.log("fileName",file.name);
                    });
               
            },
            uploadStart(file){
               
            },
            onFileProgress(rootFile, file, chunk) {//文件上传进度的
                
                console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            }, 

            //文件上传完成
            onFileSuccess(rootFile, file, response, chunk) { // 内部自动调用
            let res = JSON.parse(response);
            this.$message({ message: "上传完成", type: 'success' });//弹框
            var  params={       
                Token:rootFile.uniqueIdentifier,
                Filename:rootFile.name
            }
            this.$api.SimpleUploadMerge(params).then(res => {//告诉后台已经上传完成了
                    console.log("res=====",res);
                    this.uploadSuccess=true;
                });
            },
            //文件上传失败
            onFileError(rootFile, file, response, chunk) {
                this.$message({
                    message: response,
                    type: 'error'
                })
            },

            //上传结束
            addInpData(index,value){
                var str = 'and  '+value +"=\'  \'  "
                this.btnData[index].isDisabled =true;
                if(this.$util.isnull(this.inpData)){//有值的时候
                    this.inpData +=str;
                }else{//没有值的时候
                    this.inpData = value+"=\'  \'  "
                }
            },
            handleClick(row) {
                console.log(row);
            },
            searchClick(){//查询
                this.logining = true;
                console.log("selectValue",this.selectValue);
                console.log("inpData",this.inpData);
                var selectValue = this.selectValue;
                var inpData = this.inpData;
               
                if(!selectValue||!inpData){
                    this.$alert('请输入查询条件', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.logining = false;
                        }
                    });
                }else{
                    var Params = {
                        SearchConditions:inpData,
                        KbaseViewName:selectValue
                    }
                    console.log(sessionStorage.getItem("Authorization"))
                    this.$api.getTabData(Params).then(res => {
                    this.logining = false;
                    if(res.status==200){
                        this.tabData = res.data;
                    } 
                });
                }
            },
            resetClick(){//重置
                this.inpData='';
            }
            
            },
		  data() {
			return {
                loadOptions: {
                    // https://github.com/simple-uploader/Uploader/tree/develop/samples/Node.js
                    target: 'http://192.168.25.114/km/api/Upload/SimpleUpload',
                    headers:{Authorization:sessionStorage.getItem("Authorization")},
                    autoStart :false,
                    testChunks: true,   //是否开启服务器分片校验
                    chunkSize:3* 1024 * 1024,
                    simultaneousUploads :3,//最大并发数为1
                    parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {//剩余时间的格式化
                        return parsedTimeRemaining
                            .replace(/\syears?/, '年')
                            .replace(/\days?/, '天')
                            .replace(/\shours?/, '小时')
                            .replace(/\sminutes?/, '分钟')
                            .replace(/\sseconds?/, '秒')
                    },
                    
                },
                single :false,
                attrs: {accept: 'image/*'},
                fileStatusText(status, response) {//用于转换文件上传状态文本映射对象
                        const statusTextMap = {
                            uploading: 'uploading',
                            paused: '暂停中...',
                            waiting: '等待...'
                        }
                        if (status === 'success' || status === 'error') {
                            // 只有status为success或者error的时候可以使用 response
                            // eg:
                            // return response data ?
                            //return response.data
                            if(status === 'success')
                            {
                                return "上传成功"
                            
                            }else{
                                return "上传失败"
                            }
                            
                        } else {
                            return statusTextMap[status]
                        }
                },
                uploadSuccess:false,
                panelShow: false, 
                dialogTableVisible: false,
                logining:false,
                filters:{
                     name:""
                 },
                 inpData:"",
                 options: [{//下拉框数据
                    value: 'CJFDCONTENT',
                    label: '期刊'
                    }, {
                    value: 'CDFDCONTENT',
                    label: '博硕'
                    }, {
                    value: 'CPFDCONTENT',
                    label: '会议'
                    }, {
                    value: 'CCNDCONTENT',          
                    label: '报纸'
                    }],
                    selectValue: '',
                    tabData:'',
                    btnData:[{//输入框下的按钮数据
                        value:'篇名',
                        name:"篇名",
                        isDisabled:false
                    },
                    {
                        value:'作者',
                        name:"作者",
                        isDisabled:false
                    },
                    {
                        value:'日期',
                        name:"日期",
                        isDisabled:false
                    },
                    {
                        value:'文件名',
                        name:"文件名",
                        isDisabled:false
                    }
                    ],
                    
            }
          }
	 
	}

</script>

<style scoped lang='scss'>
    .show-remove  .uploader-file-remove{
        display:block!important;
        background-position-y: -34px;
    }
    .cancel_main{
        width:100%;
        .tab_box{
            width:100%;
        }
    }
    .inp_box{
        width:100%;
        padding-bottom:10px;
        background: #f2f2f2; 
    }
    .toolbar{
        //height:60px;
       
    }
    .inp_item{
        width:600px;
        margin-right: 10px;
    }
    .tab_itemBox{
        // height:60px;
        border-bottom:1px solid #EBEEF5;
        // border-top:1px solid #EBEEF5;
        // line-height: 60px;
        margin-top:40px;
        .tab_title{
            padding-left:15px;
            color:#72bff3;
            font-size: 18px;
            font-weight: bold;
            margin-bottom:10px;
            // line-height: 40px;
        }
    }
    .btn_box{
        margin-left:230px;
    }
    .uploader-example {
        width: 880px;
        padding: 15px;
        margin: 40px auto 0;
        font-size: 12px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .4);
    }
    .uploader-example .uploader-btn {
        margin-right: 4px;
    }
    .uploader-example .uploader-list {
        max-height: 440px;
        overflow: auto;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .show-remove .uploader-list .uploader-file[status=success] .uploader-file-remove{
        display:block!important;
        background-position-y: -34px;
    }
    
</style>   


// WEBPACK FOOTER //
// cancelPaper.vue?24514db0